"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return sortV2;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
const _sqlSanitize = require("~/helpers/sqlSanitize");
const _generateLookupSelectQuery = /*#__PURE__*/ _interop_require_default(require("~/db/generateLookupSelectQuery"));
const _helpers = require("~/helpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function sortV2(baseModelSqlv2, sortList, qb, alias, throwErrorIfInvalid = false) {
    const knex = baseModelSqlv2.dbDriver;
    const context = baseModelSqlv2.context;
    if (!(sortList == null ? void 0 : sortList.length)) {
        return;
    }
    for (const _sort of sortList){
        let sort;
        if (_sort instanceof _models.Sort) {
            sort = _sort;
        } else {
            sort = new _models.Sort(_sort);
        }
        const column = await (0, _helpers.getRefColumnIfAlias)(context, await sort.getColumn(context));
        if (!column) {
            if (throwErrorIfInvalid) {
                _catchError.NcError.get(context).fieldNotFound(sort.fk_column_id);
            }
            continue;
        }
        const model = await column.getModel(context);
        const nulls = sort.direction === 'desc' ? 'LAST' : 'FIRST';
        switch(column.uidt){
            case _nocodbsdk.UITypes.Rollup:
            case _nocodbsdk.UITypes.Links:
                {
                    const builder = (await (0, _genRollupSelectv2.default)({
                        baseModelSqlv2,
                        knex,
                        columnOptions: await column.getColOptions(context),
                        alias
                    })).builder;
                    qb.orderBy(builder, sort.direction || 'asc', nulls);
                }
                break;
            case _nocodbsdk.UITypes.Formula:
            case _nocodbsdk.UITypes.Button:
                {
                    const formulaOptions = await column.getColOptions(context);
                    if (column.uidt === _nocodbsdk.UITypes.Formula || column.uidt === _nocodbsdk.UITypes.Button && formulaOptions.type === 'url') {
                        const parsedTree = formulaOptions.getParsedTree();
                        // if static value order by a static number to avoid error
                        if ((parsedTree == null ? void 0 : parsedTree.type) === 'Literal') {
                            qb.orderBy(knex.raw('?', [
                                1
                            ]), sort.direction || 'asc', nulls);
                            break;
                        }
                        const builder = (await (0, _formulaQueryBuilderv2.default)({
                            baseModel: baseModelSqlv2,
                            tree: formulaOptions.formula,
                            model,
                            column,
                            tableAlias: alias
                        })).builder;
                        qb.orderBy(builder, sort.direction || 'asc', nulls);
                    } else {
                        // The fk_webhook_id is a static value
                        qb.orderBy(knex.raw('?', [
                            1
                        ]), sort.direction || 'asc', nulls);
                    }
                }
                break;
            case _nocodbsdk.UITypes.Lookup:
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                {
                    const rootAlias = alias;
                    {
                        const selectQb = await (0, _generateLookupSelectQuery.default)({
                            baseModelSqlv2,
                            column,
                            alias: rootAlias,
                            model
                        });
                        qb.orderBy(selectQb == null ? void 0 : selectQb.builder, sort.direction || 'asc', nulls);
                    }
                }
                break;
            case _nocodbsdk.UITypes.SingleSelect:
                {
                    const clientType = knex.clientType();
                    if (clientType === 'mysql' || clientType === 'mysql2') {
                        qb.orderBy((0, _sqlSanitize.sanitize)(knex.raw('CONCAT(??)', [
                            column.column_name
                        ])), sort.direction || 'asc', nulls);
                    } else {
                        qb.orderBy((0, _sqlSanitize.sanitize)(column.column_name), sort.direction || 'asc', nulls);
                    }
                    break;
                }
            case _nocodbsdk.UITypes.MultiSelect:
                {
                    const clientType = knex.clientType();
                    if (clientType === 'mysql' || clientType === 'mysql2') {
                        qb.orderBy((0, _sqlSanitize.sanitize)(knex.raw('CONCAT(??)', [
                            column.column_name
                        ])), sort.direction || 'asc', nulls);
                    } else {
                        qb.orderBy((0, _sqlSanitize.sanitize)(column.column_name), sort.direction || 'asc', nulls);
                    }
                    break;
                }
            case _nocodbsdk.UITypes.User:
            case _nocodbsdk.UITypes.CreatedBy:
            case _nocodbsdk.UITypes.LastModifiedBy:
                {
                    const base = await _models.Base.get(context, model.base_id);
                    const baseUsers = await _models.BaseUser.getUsersList(context, {
                        base_id: base.id,
                        include_internal_user: true
                    });
                    // create nested replace statement for each user
                    const finalStatement = baseUsers.reduce((acc, user)=>{
                        const qb = knex.raw(`REPLACE(${acc}, ?, ?)`, [
                            user.id,
                            user.display_name || user.email
                        ]);
                        return qb.toQuery();
                    }, knex.raw(`??`, [
                        column.column_name
                    ]).toQuery());
                    qb.orderBy((0, _sqlSanitize.sanitize)(knex.raw(finalStatement)), sort.direction || 'asc', nulls);
                    break;
                }
            case _nocodbsdk.UITypes.LongText:
                {
                    if ((0, _nocodbsdk.isAIPromptCol)(column)) {
                        let col;
                        if (knex.clientType() === 'pg') {
                            col = knex.raw(`TRIM('"' FROM (??::jsonb->>'value'))`, [
                                column.column_name
                            ]);
                        } else if (knex.clientType().startsWith('mysql')) {
                            col = knex.raw(`JSON_UNQUOTE(JSON_EXTRACT(??, '$.value'))`, [
                                column.column_name
                            ]);
                        } else if (knex.clientType() === 'sqlite3') {
                            col = knex.raw(`json_extract(??, '$.value')`, [
                                column.column_name
                            ]);
                        }
                        qb.orderBy(col, sort.direction || 'asc', nulls);
                    } else {
                        qb.orderBy((0, _sqlSanitize.sanitize)(column.column_name), sort.direction || 'asc', nulls);
                    }
                    break;
                }
            default:
                qb.orderBy((0, _sqlSanitize.sanitize)(column.column_name), sort.direction || 'asc', nulls);
                break;
        }
    }
}
